// mapRelativeToMember.js
import relationshipLabel, { getInverseRelationshipLabel } from "./relationshipLabel";
import getAvatarUrl from "./getAvatarUrl";

export default function mapRelativeToMember(raw = {}, currentUserId) {
  const id = raw._id || raw.id || null;
  const status = raw.status || "pending";

  // ✅ Suis-je celui qui a créé la relation ?
  const iAmInitiator = String(raw.userId) === String(currentUserId);

  // ✅ Relation affichée selon la perspective
  // - Si j'ai invité : je vois ce que j'ai choisi  (brother)
  // - Si j'ai été invité : je vois l'inverse        (sister)
  const relationship = iAmInitiator
    ? relationshipLabel(raw.relationshipType)
    : getInverseRelationshipLabel(raw.relationshipType);

  // ✅ Nom affiché = toujours l'AUTRE personne
  let name = "Unknown user";
  let avatar = null;

  if (iAmInitiator) {
    // J'ai créé → l'autre est relativeUser
    if (raw.relativeUser) {
      name = `${raw.relativeUser.firstName || ""} ${raw.relativeUser.lastName || ""}`.trim();
      avatar = getAvatarUrl(raw.relativeUser.avatar);
    }
  } else {
    // J'ai été invité → l'autre est user (celui qui a créé)
    const other = raw.user || raw.createdByUser || null;
    if (other) {
      name = `${other.firstName || ""} ${other.lastName || ""}`.trim();
      avatar = getAvatarUrl(other.avatar);
    } else if (raw.relativeUser) {
      // fallback si backend ne retourne pas raw.user
      name = `${raw.relativeUser.firstName || ""} ${raw.relativeUser.lastName || ""}`.trim();
      avatar = getAvatarUrl(raw.relativeUser.avatar);
    }
  }

  return {
    id,
    relationship,
    name,
    avatar,
    status,
    userId:     raw.userId,
    relativeId: raw.relativeId,
  };
}